import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useLoading } from "../../../../components/Loading";
import {  useState } from "react";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";
import DropDownConfig from "../../../Utils/DropDownConfig";


const InsurerRegistryFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const {setCircleLoading} = useLoading();
    const {showSnackbar} = useSnackbar();

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openState, setOpenState] = useState(false);
    const [openWidgetType, setOpenWidgetType] = useState(false);
    const [openDataType, setOpenDataType] = useState(false);
    const [openGeneralProduct, setOpenGeneralProduct] = useState(false);

    //options states
    const [generalInsurerOptions, setGeneralInsurerOptions] = useState([]);
    const [widgetTypeOptions, setWidgetTypeOptions] = useState([]);
    const [dataTypeOptions, setDataTypeOptions] = useState([]);
    const [generalProductOptions, setGeneralProductOptions] = useState([]);
    
    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "2px 6px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    const fetchGeneralInsurerList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/general/insurer-master?dropdown=true`)
            
            if(response?.success){
                const formattedOptions = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.companyName,
                }));
                
                setGeneralInsurerOptions(formattedOptions)
            }
            else{
                //throw error
                showSnackbar("Error Fetching List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Data:', error);
            showSnackbar("Error Fetching List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchWidgetTypeList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/api-engine/key-value-store?dropdown=true&code=${DropDownConfig?.apiWidgetType}`)

            if(response?.success){
                const formattedOptions = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setWidgetTypeOptions(formattedOptions)
            }
            else{
                //throw error
                showSnackbar("Error Fetching List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Data:', error);
            showSnackbar("Error Fetching List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchDataTypeList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`api-engine/key-value-store?dropdown=true&code=${DropDownConfig?.apiDataType}`)

            if(response?.success){
                const formattedOptions = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.keyName,
                }));
                setDataTypeOptions(formattedOptions)
            }
            else{
                //throw error
                showSnackbar("Error Fetching List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Data:', error);
            showSnackbar("Error Fetching List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchGeneralProductList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/general/key-value-store?code=${DropDownConfig?.generalProduct}&dropdown=true`)

            if(response?.success){
                const formattedOptions = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.keyName,
                }));
                setGeneralProductOptions(formattedOptions)
            }
            else{
                //throw error
                showSnackbar("Error Fetching List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Data:', error);
            showSnackbar("Error Fetching List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            gInsurerId: "",
            gProductId: "",
            gLobId: ""
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 240,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",             
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                Insurer Registry Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
        maxHeight: 300, 
        overflowY: "auto"}}>
            <Grid2 container>
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* General Insurer*/}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openState;
                            setOpenState(nextState);

                            if (nextState && generalInsurerOptions.length === 0) {
                                fetchGeneralInsurerList();
                            }
                        }}                        
                            >
                            <MaterialTypography variant="body3" fontWeight="bold">
                            General Insurer
                            </MaterialTypography>

                            <IconButton size="small">
                            <ExpandMore
                                sx={{
                                transform: openState ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                                }}
                            />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openState}>
                            {generalInsurerOptions?.map((state) => (
                            <MenuItem
                                key={state.value}
                                disableRipple
                                sx={menuItemStyle}
                                onClick={() =>
                                handleChange({
                                    target: { name: "gInsurerId", value: state.value },
                                })
                                }
                            >
                                <FormControlLabel
                                control={
                                    <Checkbox
                                    size="small"
                                    checked={filterData.gInsurerId === state.value}
                                    />
                                }
                                label={state.label}
                                sx={labelStyle}
                                />
                            </MenuItem>
                            ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Widget Type */}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openWidgetType;
                            setOpenWidgetType(nextState);

                            if (nextState && widgetTypeOptions.length === 0) {
                                fetchWidgetTypeList();
                            }
                        }}>
                            <MaterialTypography variant="body3" fontWeight="bold">
                                Widget Type
                            </MaterialTypography>

                            <IconButton size="small">
                                <ExpandMore
                                sx={{
                                    transform: openWidgetType ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "0.2s",
                                }}
                                />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openWidgetType}>
                        {widgetTypeOptions?.map((district) => (
                            <MenuItem
                            key={district.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "widgetTypeId", value: district.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={
                                <Checkbox
                                    size="small"
                                    checked={filterData.widgetTypeId === district.value}
                                />
                                }
                                label={district.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Data Type */}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openDataType;
                            setOpenDataType(nextState);

                            if (nextState && dataTypeOptions.length === 0) {
                                fetchDataTypeList();
                            }
                        }}>
                            <MaterialTypography variant="body3" fontWeight="bold">
                                Data Type
                            </MaterialTypography>

                            <IconButton size="small">
                                <ExpandMore
                                sx={{
                                    transform: openDataType ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "0.2s",
                                }}
                                />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openDataType}>
                        {dataTypeOptions?.map((district) => (
                            <MenuItem
                            key={district.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "dataTypeId", value: district.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={
                                <Checkbox
                                    size="small"
                                    checked={filterData.dataTypeId === district.value}
                                />
                                }
                                label={district.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* General Product */}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openGeneralProduct;
                            setOpenGeneralProduct(nextState);

                            if (nextState && generalProductOptions.length === 0) {
                                fetchGeneralProductList();
                            }
                        }}>
                            <MaterialTypography variant="body3" fontWeight="bold">
                                General Product
                            </MaterialTypography>

                            <IconButton size="small">
                                <ExpandMore
                                sx={{
                                    transform: openGeneralProduct ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "0.2s",
                                }}
                                />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openGeneralProduct}>
                        {generalProductOptions?.map((district) => (
                            <MenuItem
                            key={district.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "gProductId", value: district.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={
                                <Checkbox
                                    size="small"
                                    checked={filterData.gProductId === district.value}
                                />
                                }
                                label={district.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
            </Grid2>
        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            minWidth: "0px",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#bcc7e9",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#93a6e8",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default InsurerRegistryFilterDialog;
